import axiosInstance, { BASE_URL } from "./instance";

const APPOINTMENT_DOMAIN = `${BASE_URL}/appointment`;

const getData = () => {
  return axiosInstance.get(`${APPOINTMENT_DOMAIN}/appointment?source=online`);
};

const getAvailableTime = (data: {
  staffIds: Array<string>;
  startWeek: string;
  endWeek: string;
  duration: number;
  timezone: string;
}) => {
  return axiosInstance.post(`${APPOINTMENT_DOMAIN}/appointment/available`, {
    ...data,
  });
};

const createAppointment = (data: {
  id: string;
  customerName: string;
  customerPhone?: string;
  customerEmail?: string;
  date: number;
  services: Array<{
    id: string;
    name: string;
    staffId: string;
    duration: number;
    startTime: string;
    endTime: string;
    request: boolean;
  }>;
  status: string;
  note?: string;
}) => {
  return axiosInstance.post(`${APPOINTMENT_DOMAIN}/appointment`, { ...data });
};

const appointmentServices = {
  getData,
  getAvailableTime,
  createAppointment,
};

export default appointmentServices;
